import actionTypes from '../constants/action-types';
import type { EcommercePlans } from '../types/ecommerce-plan';
import type { PayloadAction } from '../types/actions';

const ecommercePlans = (
  state: EcommercePlans | null = null,
  action: PayloadAction<EcommercePlans>
): EcommercePlans | null => {
  if (action.type === actionTypes.SET_ECOMMERCE_PLANS) {
    return action.payload;
  }

  return state;
};

export default ecommercePlans;
